import styled from 'styled-components';

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
`;

export const ErrorTitle = styled.h2`
  margin-bottom: 1rem;
  font-size: 1.5rem;
  font-weight: bold;
  color: black;
`;

export const ErrorMessage = styled.p`
  margin-bottom: 1rem;
  color: #4b5563;
`;

export const RetryButton = styled.button`
  padding: 0.5rem 1rem;
  background-color: #fa6831;
  color: white;
  border-radius: 0.375rem;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;
